import { render, staticRenderFns } from "./PolTypeList.vue?vue&type=template&id=7cbb11af&"
import script from "./PolTypeList.vue?vue&type=script&lang=js&"
export * from "./PolTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports